export const FIXED_FUND = 'fixed';
export const TRANSACTION_FEE_PERCENTAGE = 0.025;
export const UNLIMITED_FUND = 'unlimited';

export * from './unleash';
